import { Button, Drawer, List } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { clearAllError } from "@/stores/slice/errorSlice/errorSlice";
 import { useDispatch } from "react-redux";
import { RemoveFormatting } from "lucide-react";

const Notificationlist = ({ setShowNotification, showNotifications }) => {
  const { errorlist } = useSelector((state) => state.errorInfo);
  const dispatch = useDispatch();
   const onClose = () => {
    setShowNotification(false);
  };

  return (
    <div>
      <Drawer
        title="Notifications"
        width={600}
        style={{ paddingRight: "10px" }} 
        onClose={onClose}
        visible={showNotifications}
        extra={
          <Button
            
            onClick={() => {
              dispatch(clearAllError());
            }}
            icon={<RemoveFormatting />}
          >
            Clear
          </Button>
        }
      >
        <List
          dataSource={errorlist}
          renderItem={(item, index) => (
            <List.Item key={index}>
              <List.Item.Meta
                title={`Error at ${item.timestamp}`}
                description={item.errors.map((error, idx) => (
                  <div key={idx}>
                    <strong>{error.tablename}:</strong> {error.error}
                  </div>
                ))}
              />
            </List.Item>
          )}
        />
      </Drawer>
    </div>
  );
};

export default Notificationlist;
